import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { fetchCandidateSkillsApi } from '../../API/API'

function* candidateSkillSaga(params) {
    try {
        const response = yield call(() => fetchCandidateSkillsApi(params)); 
        yield put({type: types.FETCH_CANDIDATE_SKILLS_SUCCESS, payload: response.data});
      }
      catch (error) {
        yield put({type: types.FETCH_CANDIDATE_SKILLS_FAILURE, error});
    }
}

export function* watchCandidateSkillSaga() {
    yield takeEvery(types.FETCH_CANDIDATE_SKILLS_INIT, candidateSkillSaga);
}